import { parseTtqasQrPayload } from './ttqasQrAnchor';

declare global {
  interface Window {
    BarcodeDetector?: new (options?: { formats?: string[] }) => {
      detect: (source: ImageBitmapSource) => Promise<Array<{ rawValue?: string }>>;
    };
  }
}

async function loadImageBitmap(file: File): Promise<ImageBitmap> {
  if (typeof createImageBitmap === 'function') {
    return createImageBitmap(file);
  }
  const url = URL.createObjectURL(file);
  try {
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('无法读取图片'));
      img.src = url;
    });
    return createImageBitmap(image);
  } finally {
    URL.revokeObjectURL(url);
  }
}

/** Best-effort QR decode for answer-sheet uploads on Web (BarcodeDetector). */
export async function decodeAnswerSheetQrFromFile(file: File): Promise<string | null> {
  if (!window.BarcodeDetector) {
    return null;
  }
  try {
    const detector = new window.BarcodeDetector({ formats: ['qr_code'] });
    const bitmap = await loadImageBitmap(file);
    const results = await detector.detect(bitmap);
    if (typeof bitmap.close === 'function') {
      bitmap.close();
    }
    for (const entry of results) {
      const raw = String(entry.rawValue || '').trim();
      if (raw) return raw;
    }
  } catch {
    return null;
  }
  return null;
}

export function parseTtqasAnchorFromFileQr(raw: string | null | undefined) {
  if (!raw) return null;
  return parseTtqasQrPayload(raw);
}
